import { render, staticRenderFns } from "./PayRedirect.vue?vue&type=template&id=f88d29ee&scoped=true&"
import script from "./PayRedirect.vue?vue&type=script&lang=js&"
export * from "./PayRedirect.vue?vue&type=script&lang=js&"
import style0 from "./PayRedirect.vue?vue&type=style&index=0&id=f88d29ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f88d29ee",
  null
  
)

export default component.exports